module.exports = __webpack_public_path__ + "img/product_1.2a03a178.jpg";